import { grayPaletteDark } from '../../themes/dark-colors';

export const popMenuDarkTheme = {
  buttonBar: {
    backgroundColor: grayPaletteDark[100],
  },
  panel: {
    dividerColor: grayPaletteDark[300],
  },
};
